import * as React from 'react';
import './HorizontalLine.css';

interface HorizontalLineProps {
  paddingLeft?: string;
  paddingRight?: string;
  width?: string;
}

// tslint:disable-next-line:variable-name
const HorizontalLine: React.FC<HorizontalLineProps> = ({
  width = '100%',
  paddingLeft,
  paddingRight,
}) => {
  return (
    <div
      className={'horizontalLine'}
      style={{
        width,
        paddingLeft,
        paddingRight,
      }}
    />
  );
};

export default HorizontalLine;
